import { useEffect, useState } from "react";
import { icons } from "../../assets";
import { fetchShopSettings } from "../../api";
import PrimaryButton from "../ui/PrimaryButton";

function formatHuf(amount) {
  const value = Math.round(Number(amount) || 0);
  return `${value}.-`;
}

function CoffeeSection({ t, checkoutT, lang }) {
  const [imageFailed, setImageFailed] = useState(false);
  const [shop, setShop] = useState(null);
  const [checkoutSuccess, setCheckoutSuccess] = useState(false);
  const coffeeSrc = icons.coffee;

  useEffect(() => {
    setImageFailed(false);
  }, [coffeeSrc]);

  useEffect(() => {
    let cancelled = false;

    async function loadShop() {
      try {
        const data = await fetchShopSettings();
        if (!cancelled) setShop(data);
      } catch {
        if (!cancelled) setShop(null);
      }
    }

    loadShop();
    return () => {
      cancelled = true;
    };
  }, []);

  useEffect(() => {
    if (typeof window === "undefined") return;

    const hash = window.location.hash || "";
    const queryStart = hash.indexOf("?");
    if (queryStart === -1) return;

    const params = new URLSearchParams(hash.slice(queryStart + 1));
    if (params.get("checkout") === "success") {
      setCheckoutSuccess(true);
      window.history.replaceState({}, "", "#mizu-coffee");
    }
  }, []);

  const showImage = Boolean(coffeeSrc) && !imageFailed;
  const canBuy =
    shop?.coffeeEnabled && shop.coffeePriceHuf >= 175 && shop.shipping;

  function handleBuyClick() {
    window.location.href = `/checkout?lang=${lang}`;
  }

  return (
    <section className="landing-section coffee-section" id="mizu-coffee">
      <div className="container coffee-section-inner">
        <div className="coffee-copy">
          <p className="coffee-eyebrow">{t.eyebrow}</p>
          <h2 className="coffee-title">{t.title}</h2>
          {t.paragraphs.map((paragraph) => (
            <p key={paragraph} className="coffee-text">
              {paragraph}
            </p>
          ))}
          <p className="coffee-accent">{t.accent}</p>

          {checkoutSuccess ? (
            <p className="coffee-success" role="status">
              {checkoutT.success}
            </p>
          ) : null}

          <div className="coffee-actions">
            {canBuy ? (
              <PrimaryButton className="coffee-buy-btn" onClick={handleBuyClick}>
                {t.cta}
              </PrimaryButton>
            ) : null}
            <span className="coffee-size">
              {t.size}
              {canBuy ? (
                <span className="coffee-price">{formatHuf(shop.coffeePriceHuf)}</span>
              ) : null}
            </span>
          </div>
        </div>

        <div className="coffee-media">
          {showImage ? (
            <img
              key={coffeeSrc}
              src={coffeeSrc}
              alt={t.imageAlt}
              className="coffee-image"
              loading="eager"
              onError={() => setImageFailed(true)}
            />
          ) : (
            <div className="coffee-image-placeholder" role="img" aria-label={t.imageAlt}>
              <span className="coffee-image-placeholder-label">{t.placeholderLabel}</span>
            </div>
          )}
        </div>
      </div>
    </section>
  );
}

export default CoffeeSection;
